import React, {FC, useEffect, useState} from 'react';
import {Form, Formik} from 'formik';
import {ReactComponent as CloseIcon} from '../../assets/form/close-form.svg';
import {ReactComponent as SelectArrayIcon} from '../../assets/i/select-array-icon.svg';
import {ReactComponent as ArrowUpIconIcon} from '../../assets/i/arrow-up-icon.svg';
import {useAppDispatch, useAppSelector} from '../../common/hook';
import {Select} from "antd";
import {optionsTimeMinutes} from "./options/options";
import {setSettingPopupsAC} from "../../app/popups-reducer";
import {useParams} from "react-router-dom";
import {fetchSettingGroup} from "../../features/model/service/setting-groups/fetch-setting-group/fetchSettingGroup";
import {
    fetchChangeSettingGroup
} from "../../features/model/service/setting-groups/fetch-change-setting-group/fetchChangeSettingGroup";


interface MyFormValues {
    paramInp: boolean;
    paramInp2: boolean;
    paramInp3: boolean;
    paramInp4: boolean;
    remindStudentsTime: number
    paramInp5: boolean;
    remindTeacherTime: number
}

export const FormGroupSettings: FC = () => {
    const dispatch = useAppDispatch();
    const [open, setOpen] = useState<boolean>(false);
    const [openTwo, setOpenTwo] = useState<boolean>(false);

    const {groupId} = useParams();


    const settingsData = useAppSelector(state => state.settings.data)


    const [considerHomework, setConsiderHomework] = useState(settingsData.considerHomework)

    const [considerAttendance, setConsiderAttendance] = useState(settingsData.considerAttendance)
    const [considerProgressCuts, setConsiderProgressCuts] = useState(settingsData.considerProgressCuts)
    const [remindStudents, setRemindStudents] = useState(settingsData.remindStudents)
    const [remindStudentsTimeValue, setRemindStudentsTimeValue] = useState<number>(settingsData.remindStudentsTime);
    const [remindTeacher, setRemindTeacher] = useState(settingsData.remindTeacher)
    const [remindTeacherTimeValue, setRemindTeacherTimeValue] = useState<number>(settingsData.remindTeacherTime);


    useEffect(() => {
        dispatch(fetchChangeSettingGroup(groupId));
    }, [dispatch, groupId]);




    useEffect(() => {
        if (settingsData) {
            setConsiderHomework(settingsData.considerHomework);
            setConsiderAttendance(settingsData.considerAttendance);
            setConsiderProgressCuts(settingsData.considerProgressCuts);
            setRemindStudents(settingsData.remindStudents);
            setRemindStudentsTimeValue(settingsData.remindStudentsTime);
            setRemindTeacher(settingsData.remindTeacher);
            setRemindTeacherTimeValue(settingsData.remindTeacherTime);
        }
    }, [settingsData]);




    const handleChange = (value: number, selectName: string) => {
        if (selectName === 'remindStudentsTime') {
            setRemindStudentsTimeValue(value);
        } else if (selectName === 'remindTeacherTime') {
            setRemindTeacherTimeValue(value);
        }
    };

    const onClickHandler = () => {
        dispatch(setSettingPopupsAC(false));
    };


    const handleSubmit = async (values: MyFormValues) => {
        try {
            let remindStudentsTimeValueToSend = values.paramInp4 ? remindStudentsTimeValue : 0;
            let remindTeacherTimeValueToSend = values.paramInp5 ? remindTeacherTimeValue : 0;

            const requestData = {
                considerHomework: values.paramInp,
                considerAttendance: values.paramInp2,
                considerProgressCuts: values.paramInp3,
                remindStudents: values.paramInp4,
                remindStudentsTime: remindStudentsTimeValueToSend,
                remindTeacher: values.paramInp5,
                remindTeacherTime: remindTeacherTimeValueToSend,
            };

            await dispatch(fetchSettingGroup({ groupId: groupId, requestData: requestData }));
            onClickHandler();
        } catch (error) {
            // Handle error
        }
    };



    return (
        <Formik
            initialValues={{
                paramInp: considerHomework,
                paramInp2: considerAttendance,
                paramInp3: considerProgressCuts,
                remindStudentsTime: remindStudentsTimeValue,
                paramInp4: remindStudents,
                remindTeacherTime: remindTeacherTimeValue,
                paramInp5: remindTeacher,
            }}
            enableReinitialize={true}
            onSubmit={handleSubmit}
        >
            {() => (
                <>
                    <p className="h3 popup-title">Настройки группы</p>
                    <Form
                        id="group-settings-form"
                        className="form"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="fields-row">
                            <div className="field">
                                <p className="h4">Параметры эффективности</p>
                                <div className="checkbox-group">
                                    <div className="checkbox-item">
                                        <input
                                            id="param-inp"
                                            name="paramInp"
                                            type="checkbox"
                                            checked={considerHomework}
                                            onChange={() => setConsiderHomework(!considerHomework)}
                                        />
                                        <label htmlFor="param-inp">Учитывать домашнее задание</label>
                                    </div>
                                    <div className="checkbox-item">
                                        <input
                                            id="param-inp2"
                                            name="paramInp2"
                                            type="checkbox"
                                            checked={considerAttendance}
                                            onChange={() => setConsiderAttendance(!considerAttendance)}
                                        />
                                        <label htmlFor="param-inp2">Учитывать посещаемость</label>
                                    </div>
                                    <div className="checkbox-item">
                                        <input
                                            id="param-inp3"
                                            name="paramInp3"
                                            type="checkbox"
                                            checked={considerProgressCuts}
                                            onChange={() => setConsiderProgressCuts(!considerProgressCuts)}

                                        />
                                        <label htmlFor="param-inp3">Учитывать срезы</label>
                                    </div>
                                </div>
                                <p className="h4">Напоминания</p>


                                <div className="checkbox-group">
                                    <div id='arr1' className="checkbox-item large-indent checkbox-group-custom">
                                        <input
                                            id="reminder-inp"
                                            name="paramInp4"
                                            type="checkbox"
                                            checked={remindStudents}
                                            onChange={() => setRemindStudents(!remindStudents)}
                                        />
                                        <label htmlFor="reminder-inp">
                                            Напоминать студентам о занятиях за{' '}
                                        </label>
                                        <Select
                                            id='selectOne'
                                            value={remindStudentsTimeValue}
                                            onChange={(value) => handleChange(value, 'remindStudentsTime')}
                                            options={optionsTimeMinutes}
                                            bordered={false}
                                            onClick={(event) => event.stopPropagation()}
                                            suffixIcon={open ? <ArrowUpIconIcon /> : <SelectArrayIcon />}
                                            disabled={!remindStudents}
                                        />
                                        <label className='dop-label' htmlFor="reminder-inp">минут</label>
                                    </div>

                                    <div id='arr2' className="checkbox-item large-indent checkbox-group-custom">
                                        <input
                                            id="reminder-inp2"
                                            name="paramInp5"
                                            type="checkbox"
                                            checked={remindTeacher}
                                            onChange={() => setRemindTeacher(!remindTeacher)}
                                        />
                                        <label htmlFor="reminder-inp2">
                                            Напоминать учителю о занятиях за
                                        </label>
                                        <Select
                                            id='selectTwo'
                                            value={remindTeacherTimeValue}
                                            onChange={(value) => handleChange(value, 'remindTeacherTime')}
                                            options={optionsTimeMinutes}
                                            bordered={false}
                                            onClick={(event) => event.stopPropagation()}
                                            suffixIcon={openTwo ? <ArrowUpIconIcon /> : <SelectArrayIcon />}
                                            disabled={!remindTeacher}
                                        />
                                        <label className='dop-label' htmlFor="reminder-inp2">минут</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button type="submit" className="btn full-width">
                            <span>Сохранить изменения</span>
                        </button>
                    </Form>
                    <span onClick={onClickHandler} className="js-close-popup">
            <CloseIcon/>
          </span>
                </>
            )}
        </Formik>
    );
};
